import { IGeneralContext } from '@picsart/miniapps-sdk';
import { DAILY_ALLOWANCE } from "../constants";

export function allowanceReached({ internals }: IGeneralContext) {
  if (DAILY_ALLOWANCE === 0) return false;
  return (internals.state.limit?.remaining ?? 1) <= 0;
}
